module.exports = __webpack_public_path__ + "img/4.bb3c6b6e.png";